import React from "react";
import { Form, Row, Col, Tooltip, OverlayTrigger } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { useIntl } from "react-intl";
import { Card, CardBody } from "../../../_metronic/_partials/controls";
import classNames from "classnames";
import { useSelector } from "react-redux";
import Select from "react-select";

const SearchWalletTransactions = (props) => {
  const { register, reset, control } = useFormContext({
    reValidateMode: "onChange",
    defaultValues: {
      transactionNumber: "",
      transactionType: null,
      walletType: null,
      status: null,
    },
  });
  const intl = useIntl();
  const { taxonomy } = useSelector((state) => state?.taxonomy);

  const statusFilterList = [
    {
      value: 0,
      label: intl.formatMessage({ id: "GLOBAL.STATUS.PENDING" }),
    },
    {
      value: 2,
      label: intl.formatMessage({ id: "GLOBAL.STATUS.SUCCESS" }),
    },
    {
      value: 3,
      label: intl.formatMessage({ id: "GLOBAL.STATUS.REJECTED" }),
    },
  ];

  const transactionTypeList = [
    {
      value: 0,
      label: intl.formatMessage({ id: "wallet.transactionType.investment" }),
    },
    {
      value: 1,
      label: intl.formatMessage({ id: "wallet.transactionType.topup" }),
    },
    {
      value: 2,
      label: intl.formatMessage({ id: "wallet.transactionType.withdraw" }),
    },
    {
      value: 3,
      label: intl.formatMessage({ id: "wallet.transactionType.refunded" }),
    },
    {
      value: 4,
      label: intl.formatMessage(
        { id: "wallet.transactionType.campaignUnsuccessfull" },
        { value: taxonomy?.projectSingular }
      ),
    },
    {
      value: 5,
      label: intl.formatMessage({
        id: "wallet.transactionType.distributionAdded",
      }),
    },
  ];

  const walletTypeList = [
    {
      value: "CREDIT",
      label: intl.formatMessage({ id: "wallet.walletType.credit" }),
    },
    {
      value: "DEBIT",
      label: intl.formatMessage({ id: "wallet.walletType.debit" }),
    },
  ];

  const onClearSearchData = () => {
    props.clearSearchData();

    reset();
  };

  return (
    <>
      <Card>
        <CardBody className="px-4 py-6">
          <h3 className="page-heading-text gap-1 mb-5">
            Search{" "}
            <OverlayTrigger
              overlay={
                <Tooltip id="search-transaction-tooltip">
                  Use one or more filters above to refine your search results.
                  You can combine multiple criteria for more accurate results.
                </Tooltip>
              }>
              <span className="tooltip-wrapper">
                <i className="fa fa-question-circle" />
              </span>
            </OverlayTrigger>
          </h3>
          <Row>
            <Col className="mb-5" md={6}>
              <Form.Control
                name="transactionNumber"
                placeholder={intl.formatMessage({
                  id: "wallet.search.transactionId",
                })}
                className={classNames("form-control common-search-input")}
                {...register("transactionNumber")}
              />
            </Col>
            {props?.showTransactionType && (
              <Col className="mb-5" md={6}>
                <Controller
                  name="transactionType"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      className="filter-select-container"
                      classNamePrefix="filter-select"
                      options={transactionTypeList}
                      value={
                        transactionTypeList.find(
                          (opt) => opt.value === field.value
                        ) || null
                      }
                      onChange={(option) =>
                        field.onChange(option ? option.value : null)
                      }
                      placeholder={intl.formatMessage({
                        id: "wallet.search.transactionType",
                      })}
                      isSearchable={false}
                    />
                  )}
                />
              </Col>
            )}

            {props?.showTransactionType && (
              <Col className="mb-5" md={6}>
                <Controller
                  name="walletType"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      className="filter-select-container"
                      classNamePrefix="filter-select"
                      isSearchable={false}
                      options={walletTypeList}
                      value={
                        walletTypeList.find(
                          (opt) => opt.value === field.value
                        ) || null
                      }
                      onChange={(option) =>
                        field.onChange(option ? option.value : null)
                      }
                      placeholder={intl.formatMessage({
                        id: "wallet.search.walletType",
                      })}
                    />
                  )}
                />
              </Col>
            )}
            <Col className="mb-5" md={6}>
              <Controller
                name="status"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={statusFilterList}
                    isSearchable={false}
                    className="filter-select-container"
                    classNamePrefix="filter-select"
                    value={
                      statusFilterList.find(
                        (opt) => opt.value === field.value
                      ) || null
                    }
                    onChange={(option) =>
                      field.onChange(option ? option.value : null)
                    }
                    placeholder={intl.formatMessage({
                      id: "GLOBAL.SEARCH.STATUS",
                    })}
                  />
                )}
              />
            </Col>
          </Row>
          <Row className="form-group gap-5 px-3">
            <Col md="auto" className="p-0">
              <button className="common-search-btn search-reset-btn">
                {intl.formatMessage({ id: "GLOBAL.SEARCH" })}
              </button>
            </Col>
            <Col md="auto" className="p-0">
              <button
                className="btn text-black py-2 search-reset-btn font-size-sm fw-medium bg-select-bg-clr"
                type="button"
                onClick={() => onClearSearchData()}>
                Reset
              </button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
};

export default SearchWalletTransactions;
